module.exports = __webpack_public_path__ + "img/short-course-hero.ec100541.webp";